<script>
//Repositories
import Repositories from '@/repositories';
const WorkOrdersRepository = Repositories.get('workorders');
const WorkOrderItemsRepository = Repositories.get('workorderitems');

//Main components
import AddForm from '@/components/widgets/items/select-item-with-quantity';
import GridWoItems from './components/grid-wo-items';

//Other components
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from 'vue-loading-overlay';
import ErrorView from '@/router/views/utility/error';

export default {
  props: {
    workOrderIdPublic: String,
  },
  components: {
    AddForm,
    GridWoItems,
    Loading,
    ErrorView,
  },
  data() {
    return {
      workOrder: null,
      workOrderItems: [],
      isLoading: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.workOrderIdPublic.length > 0) {
        this.isLoading = true;
        let promise1 = WorkOrdersRepository.get(this.workOrderIdPublic).then(
          (response) => {
            this.workOrder = response.data;
          }
        );

        let promise2 = WorkOrderItemsRepository.customREST
          .getByWorkOrderWithWorkOrderItemOrderItems(this.workOrderIdPublic)
          .then((response) => {
            this.workOrderItems = response.data;
          });

        Promise.all([promise1, promise2])
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          })
          .finally(() => (this.isLoading = false));
      }
    },
    workOrderItemUpdated() {
      this.isLoading = true;

      WorkOrderItemsRepository.customREST
        .getByWorkOrderWithWorkOrderItemOrderItems(this.workOrderIdPublic)
        .then((response) => {
          this.workOrderItems = response.data;
        })
        .catch(() => {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        })
        .finally(() => (this.isLoading = false));
    },
    workOrderItemDeleted(workOrderItem) {
      let foundIndex = this.workOrderItems.findIndex(
        (x) => x.idPublic == workOrderItem.idPublic
      );
      this.workOrderItems.splice(foundIndex, 1);

      this.loadData();
    },
    async itemToAdd(itemInfo) {
      if (itemInfo.quantity > 0) {
        try {
          this.isLoading = true;

          let queryModel = {
            idPublic: null,
            itemIdPublic: itemInfo.item.idPublic,
            workOrderIdPublic: this.workOrder.idPublic,
            totalQuantity: itemInfo.quantity,
          };

          let createResp = await WorkOrderItemsRepository.create(queryModel);

          this.$toast.successToast(this.$t('items.itemAdded'));
        } catch (error) {
          this.$toast.errorToast(this.$t('errors.errorLoading'));
        } finally {
          this.isLoading = false;
        }

        this.loadData();
      }
    },
    automaticReservation(categoryTypeIdPublic) {
      this.isLoading = true;
      WorkOrdersRepository.actions
        .automaticReservation(categoryTypeIdPublic, this.workOrderIdPublic)
        .then(() => {
          this.isLoading = false;
          this.loadData();
        })
        .catch((error) => {
          this.isLoading = false;
          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgain'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
          this.loadData();
        });
    },
  },
  computed: {
    currencyFormatter() {
      return this.$store.state.cache.currencyFormatter;
    },
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>

    <div v-if="workOrder != null">
      <b-row>
        <b-col cols="8">
          <h1>{{ workOrder.name }}</h1>
        </b-col>
        <b-col cols="4" class="text-right">
          <h1>{{ currencyFormatter.format(workOrder.totalItemsPrice) }}</h1>
        </b-col>
      </b-row>
      <b-row class="mb-3">
        <b-col cols="9">
          <AddForm @item-to-add="itemToAdd" />
        </b-col>
        <b-col class="text-right align-bottom mt-auto">
          <b-button
            type="button"
            style="height: 40px"
            variant="success"
            @click="automaticReservation(null)"
          >
            {{ $t('workOrders.automaticReservations') }}
          </b-button>
        </b-col>
      </b-row>

      <GridWoItems
        :workOrderItems="workOrderItems"
        @wo-item-updated="workOrderItemUpdated"
        @wo-item-deleted="workOrderItemDeleted"
        @automatic-reservation="automaticReservation"
      />
    </div>
    <ErrorView
      :message="$t('workOrders.workOrderNotFound')"
      v-if="workOrder == null && isLoading == false"
    />
  </div>
</template>
